/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const typography: ThemeOptions = {
	typography: {
		htmlFontSize: 15,
		fontFamily: ['Open Sans', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
		h1: {
			fontSize: 36,
			fontWeight: 600,
		},
		h2: {
			fontSize: 32,
			fontWeight: 600,
		},
		h3: {
			fontSize: 24,
			fontWeight: 600,
		},
		h4: {
			fontSize: 24,
			fontWeight: 500,
		},
		h5: {
			fontSize: 'var(--font-size-md)',
			fontWeight: 600,
		},
		h6: {
			fontSize: 'var(--font-size-md)',
			fontWeight: 500,
		},
		subtitle1: {
			fontSize: 'var(--font-size-md)',
			fontWeight: 600,
		},
		subtitle2: {
			fontSize: 'var(--font-size-md)',
			fontWeight: 400,
		},
		body1: {
			fontSize: 'var(--font-size-body)',
			fontWeight: 400,
		},
		body2: {
			fontSize: 'var(--font-size-body)',
			fontWeight: 600,
		},
		button: {
			fontSize: 'var(--font-size-body)',
			textTransform: 'none',
		},
		caption: {
			fontSize: 'var(--font-size-small)',
			fontWeight: 400,
		},
		strong: {
			fontWeight: 600,
		},
		overline: {
			fontSize: 'var(--font-size-small)',
			textTransform: 'uppercase',
			fontWeight: 600,
			letterSpacing: 1,
		},
	},
};

declare module '@mui/material/Button' {
	interface ButtonPropsVariantOverrides {
		inline: true;
	}
}
